import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import { ADD_BILLINGPRICEDETAILS, ADD_BILLINGREQUESTAPPROVAL, ADD_BILLINGGENERATEINVOICE, GET_BILLINGINVOICEDETAILS, GET_BILLINGLIST, GET_BILLINGPRICEDETAILS, GET_BILLINGEXTRACHARGECALCULATION, ADD_BILLINGCONSOLIDATEDINVOICE, GET_BILLINGCONSOLIDATEDINVOICE, GET_CONSOLIDATE_INVOICE_MATRIX, GET_FINAL_INVOICE,ADD_BILLINGREQUESTAPPROVALLINK } from "resources/actionTypes";
import { addBillingPriceDetailsService, billingConsolidatedInvoiceService, billingExtraChargeCalcService, billingGenerateInvoiceService, billingInvoiceDetailsService, billingListService, billingPriceDetailsService, billingRequestApprovalService, consolidateInvoiceMatrixService, finalInvoiceService, getbillingConsolidatedInvoiceService,billingRequestApprovalLinkService } from "services/BillingService";
import store from "redux/store";
import { getBillingList } from "redux/actions/BillingAction";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* getBillingListListener(action) {
  const payload = action.payload || {};
  const billingList = yield call(billingListService, payload);
  if (billingList.success) {
    yield put({ type: GET_BILLINGLIST.GET_BILLINGLIST_SUCCESS, billingList: billingList });
  } else {
    yield put({ type: GET_BILLINGLIST.GET_BILLINGLIST_FAILED, message: billingList.message });
    toast.error(billingList?.message || "Failed to Fetch BillingList");
  }
}

export function* getBillingListWatcher() {
  yield takeEvery(GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED, getBillingListListener);
}

function* getBillingDetails(action) {
  const payload = action.payload || {};
  const billingInvoiceDetails = yield call(billingInvoiceDetailsService, payload);
  if (billingInvoiceDetails.success) {
    yield put({ type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_SUCCESS, billingInvoiceDetails: billingInvoiceDetails });
  } else {
    yield put({ type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_FAILED, message: billingInvoiceDetails.message });
    toast.error(billingInvoiceDetails?.message || "Failed to Fetch billing Invoice Details");
  }
}

export function* getBillingDetailsWatcher() {
  yield takeEvery(GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED, getBillingDetails);
}

// Billing Details
function* getBillingPriceDetails(action) {
  const payload = action.payload || {};
  const billingPrice = yield call(billingPriceDetailsService, payload);
  if (billingPrice.success) {
    yield put({ type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_SUCCESS, billingPriceDetails: billingPrice });
  } else {
    yield put({ type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_FAILED, message: billingPrice.message });
    toast.error(billingPrice?.message || "Failed to Fetch billing Price Details");
  }
}

export function* getBillingPriceDetailsWatcher() {
  yield takeEvery(GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED, getBillingPriceDetails);
}

// add Billing Price Details
function* addtBillingPriceDetails(action) {
  const payload = action.payload || {};
  const billingPrice = yield call(addBillingPriceDetailsService, payload);
  if (billingPrice.success) {
    yield put({ type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_SUCCESS, billingPriceDetails: billingPrice });
    //navigate to invoice page after invoice is generated
    payload?.navigate();
  } else {
    yield put({ type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_FAILED, message: billingPrice.message });
    toast.error(billingPrice?.message || "Failed to Add billing Price Details");
  }
}

export function* addtBillingPriceDetailsWatcher() {
  yield takeEvery(ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_REQUESTED, addtBillingPriceDetails);
}

// Billing Request Approval
function* postBillingRequestApproval(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingRequest = yield call(billingRequestApprovalService, payload?.dataObj);
  if (billingRequest.success) {
    yield put({ type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_SUCCESS, billingRequest: billingRequest });
    // payload?.toggle();
    toast.success("Email Sent Successfully");
  } else {
    yield put({ type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_FAILED, message: billingRequest.message });
    toast.error(billingRequest?.message || "Failed to Fetch billing Request");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingRequestApprovalWatcher() {
  yield takeEvery(ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED, postBillingRequestApproval);
}

// Billing Consolidated Invoice
function* postBillingConsolidatedInvoice(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingConsolidatedRequest = yield call(billingConsolidatedInvoiceService, payload?.dataObj);
  if (billingConsolidatedRequest.success) {
    toast.success(billingConsolidatedRequest.message);
    yield put({ type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS, billingConsolidatedRequest: billingConsolidatedRequest});
    payload?.handleTotalAmount();
    store.dispatch(getBillingList(payload?.billingListPayload));
  } else {
    yield put({ type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_FAILED, message: billingConsolidatedRequest.message });
    toast.error(billingConsolidatedRequest?.message || "Failed to Add billing Consolidated Invoice");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingConsolidatedInvoiceWatcher() {
  yield takeEvery(ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED, postBillingConsolidatedInvoice);
}

//get  Billing Consolidated Invoice
function* getBillingConsolidatedInvoice(action) {
  const payload = action.payload || {};
  const billingConsolidatedInvoice = yield call(getbillingConsolidatedInvoiceService, payload);
  if (billingConsolidatedInvoice?.success) {
    yield put({ type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS, billingConsolidatedInvoice: billingConsolidatedInvoice});
  } else {
    yield put({ type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_FAILED, message: billingConsolidatedInvoice?.message });
    toast.error(billingConsolidatedInvoice.message || "Failed to fetch consolidated Invoice");
  }
}

export function* getBillingConsolidatedInvoiceWatcher() {
  yield takeEvery(GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED, getBillingConsolidatedInvoice);
}

//Billing generate perfoma invoice
function* postBillingGenerateInvoice(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingGenerateInvoice = yield call(billingGenerateInvoiceService, payload);
  if (billingGenerateInvoice.success) {
    toast.success(billingGenerateInvoice?.message || "Invoice Generated Successfully");
    payload?.handleBack();
    yield put({ type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_SUCCESS, billingGenerateInvoice: billingGenerateInvoice });
  } else {
    yield put({ type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_FAILED, message: billingGenerateInvoice.message });
    toast.error(billingGenerateInvoice?.message || "Failed to Fetch Billing generate Invoice");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingGenerateInvoiceWatcher() {
  yield takeEvery(ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED, postBillingGenerateInvoice);
}

//Billing extra charge calculation
function* getBillingExtraChargeCalc(action) {
  const payload = action.payload || {};
  const extraCharges = yield call(billingExtraChargeCalcService, payload);
  if (extraCharges.success) {
    yield put({ type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_SUCCESS, chargesCalculations: extraCharges });
  } else {
    yield put({ type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_FAILED, message: extraCharges.message });
    toast.error(extraCharges?.message || "Failed to Fetch Billing Extra charges");
  }
}

export function* getBillingExtraChargeCalcWatcher() {
  yield takeEvery(GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED, getBillingExtraChargeCalc);
}

//Consolidate Matrix Billing
function* getConsolidateInvoiceMatrix(action) {
  const payload = action.payload || {};
  const consolidateInvoiceMatrix = yield call(consolidateInvoiceMatrixService,payload);
  if(consolidateInvoiceMatrix.success){
    yield put({type:GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS,consolidateInvoiceMatrix:consolidateInvoiceMatrix});

  }else{
    yield put({ type:GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_FAILED,message:consolidateInvoiceMatrix.message});
    toast.error(consolidateInvoiceMatrix?.message || "Failed to fetch Consolidate Invoice Matrix");
  }
}

export function* getConsolidateInvoiceMatrixWatcher() {
  yield takeEvery(GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED,getConsolidateInvoiceMatrix);
}

// Final Invoice billing
function* getFinalInvoiceData(action){
  const payload = action.payload || {};
  const finalInvoiceData = yield call(finalInvoiceService,payload);
  if(finalInvoiceData.success){
    yield put({type:GET_FINAL_INVOICE.GET_FINAL_INVOICE_SUCCESS,finalInvoiceData:finalInvoiceData});
  }else{
    yield put({type:GET_FINAL_INVOICE.GET_FINAL_INVOICE_FAILED,message:finalInvoiceData?.message});
    toast.error(finalInvoiceData?.message || "Failed to fetch Final Invoice Data");
  }
}
export function* getFinalInvoiceWatcher(){
  yield takeEvery(GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED,getFinalInvoiceData);
}

// Billing Request Approval Link
function* postBillingRequestApprovalLink(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const billingRequestLink = yield call(billingRequestApprovalLinkService, payload?.dataObj);
  if (billingRequestLink.success) {
    yield put({ type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS, billingRequest: billingRequestLink });
    payload?.toggle();
  } else {
    yield put({ type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_FAILED, message: billingRequestLink.message });
    toast.error(billingRequestLink?.message || "Failed to Generate billing Request");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* postBillingRequestApprovalLinkWatcher() {
  yield takeEvery(ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED, postBillingRequestApprovalLink);
}